import { useRef } from "react";
import {
  motion,
  useMotionValue,
  useSpring,
  useTransform,
  useMotionTemplate,
} from "framer-motion";

export default function TiltCover({ src, alt, className = "", glow = "0,240,255" }) {
  const ref = useRef(null);
  const px = useMotionValue(0.5);
  const py = useMotionValue(0.5);
  const sx = useSpring(px, { stiffness: 140, damping: 18 });
  const sy = useSpring(py, { stiffness: 140, damping: 18 });

  const rotateY = useTransform(sx, [0, 1], [-9, 9]);
  const rotateX = useTransform(sy, [0, 1], [9, -9]);
  const gx = useTransform(sx, [0, 1], ["12%", "88%"]);
  const gy = useTransform(sy, [0, 1], ["12%", "88%"]);
  const glowBg = useMotionTemplate`radial-gradient(340px circle at ${gx} ${gy}, rgba(${glow},0.22), transparent 68%)`;

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    px.set((e.clientX - r.left) / r.width);
    py.set((e.clientY - r.top) / r.height);
  };
  const onLeave = () => {
    px.set(0.5);
    py.set(0.5);
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`[perspective:1300px] ${className}`}
    >
      <motion.div
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className="relative"
      >
        <div
          className="relative overflow-hidden shadow-[0_50px_90px_-20px_rgba(0,0,0,0.85)] ring-1 ring-white/10"
          style={{ transform: "translateZ(34px)" }}
        >
          <img src={src} alt={alt} className="block h-auto w-full" loading="lazy" />
          <motion.div
            style={{ background: glowBg }}
            className="pointer-events-none absolute inset-0"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.04] to-white/[0.1]" />
        </div>
        {/* light bleed beneath */}
        <div
          aria-hidden
          className="absolute -inset-x-8 -bottom-10 h-16 blur-2xl"
          style={{ background: `rgba(${glow},0.16)` }}
        />
      </motion.div>
    </div>
  );
}
